import React from 'react';
import '../index.css';

function ChannelCard({
  name,
  url,
  logo,
  group,
  year,
  isFavorite,
  toggleFavorite,
  openWithExternalPlayer,
  isSelected,
  onSelect,
}) {
  const handleClick = () => {
    onSelect();
  };

  return (
    <div
      className={`channel-card ${isSelected ? 'selected' : ''}`}
      onClick={handleClick}
    >
      {/* Logo */}
      {logo && (
        <div>
          <img
            src={logo}
            alt={name}
            style={{
              width: '100%',
              height: '200px',
              objectFit: 'cover',
            }}
          />
        </div>
      )}

      {/* Info + Buttons */}
      <div className="channel-content">
        <h4>{name}</h4>
        <small>{group} • {year}</small>

        {/* Buttons Row */}
        <div className="button-row">
          <button
            className="watch-btn"
            onClick={(e) => {
              e.stopPropagation();
              openWithExternalPlayer();
            }}
          >
            ▶️ Watch
          </button>

          <button
            className="fav-btn"
            onClick={(e) => {
              e.stopPropagation();
              toggleFavorite();
            }}
            title="Favorite"
          >
            {isFavorite ? '❤️' : '🤍'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChannelCard;
